import React from 'react';
import { Navbar, Nav, Container, Button } from 'react-bootstrap';
import { useAuth } from '../../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import './../../PAT.css'

function AdminDashboardNavbar() {
    const { currentUser, logout } = useAuth();
    let navigate = useNavigate();

    async function onClickLogOutButton(e) {
        try {
            await logout();

            navigate("/admin");
        }
        catch(error) {
            console.log(`Error while logging out: ${error}`)
        }
    }

    function onClickAdmin(e) {
        console.log('onClickAdmin');
    }

    function onClickManual(e) {
        // window.location('/assets/files/PAT_guide_admin.pdf');
        // console.log(window.location.origin);

        const url = `${window.location.origin}/assets/files/PAT_guide_admin.pdf`;

        window.open(url, '_blank').focus();
    }

    const navBrandStyle = {
        color: 'white',
        fontFamily: 'verdana',
        fontWeight: 'bold',
    }
    const navLinkStyle = {
        color: '#e0e0e0',
        fontFamily: 'verdana',
        fontWeight: 'bold',
    }

    return (
        <Navbar fixed="top" style={{ backgroundColor: 'rgba(23, 68, 120, 0.8)' }}>
            <Container fluid>
                <Navbar.Brand style={navBrandStyle} className="me-5" href="#">PAT Admin | ProjectID: {process.env.REACT_APP_FIREBASE_PROJECT_ID.toUpperCase()}</Navbar.Brand>
                <Navbar.Toggle aria-controls="navbarScroll" />
                <Navbar.Collapse id="navbarScroll">
                    <Nav
                        className="me-auto my-2 my-lg-0"
                        style={{ maxHeight: '100px' }}
                        navbarScroll
                    >
                        <Nav.Link style={navLinkStyle} onClick={onClickAdmin}>Admin</Nav.Link>
                        <Nav.Link style={navLinkStyle} onClick={onClickManual}>คู่มือ</Nav.Link>
                    </Nav>
                </Navbar.Collapse>
                <Navbar.Collapse className="justify-content-end">
                    <Navbar.Text>
                    { currentUser ? currentUser.email : null }
                    </Navbar.Text>
                    <span className='ms-2'>
                        <Button variant="outline-dark" onClick={onClickLogOutButton}>Log Out</Button>
                    </span>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
}

export default AdminDashboardNavbar;
